import React from 'react';

const COLS = [
  { title: 'A fazer', color: 'bg-gray-100 text-gray-700', cards: ['Limpeza apto 4B', 'Manutenção AC'] },
  { title: 'Em curso', color: 'bg-gray-200 text-gray-800', cards: ['Reparo elétrico'] },
  { title: 'Feito', color: 'bg-black text-white', cards: ['Pintura sala', 'Troca chuveiro'] },
];

export const ScreenKanban = React.memo(() => (
  <div className="px-3 pt-2">
    <div className="text-sm font-semibold text-black mb-3 px-1">Ordens de Serviço</div>
    <div className="flex gap-2 overflow-hidden">
      {COLS.map((col, i) => (
        <div key={i} className="flex-1 min-w-0">
          <div className={`text-[9px] font-bold uppercase tracking-wider px-2 py-1 rounded-md mb-1.5 ${col.color}`}>{col.title}</div>
          <div className="flex flex-col gap-1.5">
            {col.cards.map((c, j) => (
              <div key={j} className="bg-white border border-gray-200 rounded-lg p-2 shadow-sm">
                <div className="text-[10px] font-medium text-black leading-tight">{c}</div>
                <div className="flex items-center gap-1 mt-1.5">
                  <div className="w-4 h-4 rounded-full bg-black" />
                  <div className="text-[8px] text-gray-400">#{1000 + i * 3 + j}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
));
ScreenKanban.displayName = 'ScreenKanban';
